<template>
        <button type="button" :class="buttonClass" data-toggle="modal" :data-target="'#'+target">
                {{ content }} 
        </button>
</template>
<script>
export default {
        name: 'modalButton',
        props:{
                content: String,
                target: String,
                buttonClass: String
        }
}
</script>
<style>
</style>
